export default __webpack_public_path__ + "media/images/login-8bd155b4d368371f7262dc87f97f4ea4.svg";